import { useQuery } from '@tanstack/react-query'
import { listStudyUsersStudiesStudyIdUsersGet } from '@common/config/api/client'
import { UserListParams } from '../types'
import queryKeyFactory from '../queryKeyFactory'

export default function useUsersList(studyId: string, params: UserListParams) {
  return useQuery({
    queryKey: queryKeyFactory.users(params),
    queryFn: async () => {
      const response = await listStudyUsersStudiesStudyIdUsersGet({
        path: { study_id: studyId },
        query: {
          user_type: params.user_type,
          search: params.search,
          limit: params.limit,
          next_cursor: params.next_cursor,
          previous_cursor: params.previous_cursor,
          order_by_field: params.order_by_field,
          asc_order: params.asc_order,
        },
        throwOnError: true,
      })
      return response.data
    },
  })
}
